/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { CAPTCHA_URI } from './captcha';

const CAPTCHA_FETCH_TIMEOUT = 10000;

/**
 * In order to use the service, it must be provided in the component using the CaptchaComponent
 * (or in some module above) and the "CAPTCHA_URI" must be set.
 * It is because common-ui service is backend less and stores no endpoints.
 *
 * <pre>
 *     ...
 *     providers: [
 *       CaptchaService,
 *       { provide: CAPTCHA_URI, useValue: '/user/public/captcha/' }
 *     ],
 *     ...
 * </pre>
 */
@Injectable()
export class CaptchaService {
    constructor(
        private http: HttpClient,
        @Inject(CAPTCHA_URI) private captchaUri: string) {
    }

    public getCaptcha(): Observable<any> {
        return this.http.post(this.captchaUri, null).pipe(
            timeout(CAPTCHA_FETCH_TIMEOUT)
        );
    }
}
